var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from "react";
import Filter from "./Filter";
var FilterWrapper = function (props) {
    var filter = props.filter, tags = props.tags;
    var setFilter = (function (cb) {
        props.onFilterUpdated(cb(filter));
    });
    return (React.createElement(Filter, { filter: filter, tags: tags, onReset: function () {
            setFilter(function () {
                return {};
            });
        }, showHalfTime: filter.showHalfTime, onHalfTimeChange: function (value) {
            setFilter(function (filter) {
                return __assign(__assign({}, filter), { showHalfTime: value });
            });
        }, sortBy: filter.sort_by, onSortByChange: function (sortBy) {
            setFilter(function (filter) {
                return __assign(__assign({}, filter), { sort_by: sortBy });
            });
        }, selectedTags: filter.tags, onTagClick: function (tag) {
            var currentTags = __spreadArrays(filter.tags || []);
            var tags = Array.isArray(tag) ? tag : [tag];
            tags.forEach(function (tag) {
                if (currentTags.includes(tag.id) || currentTags.includesLowercase(tag.name)) {
                    currentTags = currentTags.filter(function (t) { return !(t == tag.id || t.toLowerCase() == tag.name.toLowerCase()); });
                }
                else {
                    currentTags.push(tag.name);
                }
            });
            setFilter(function (filter) {
                return __assign(__assign({}, filter), { tags: currentTags });
            });
        }, selectedTagGroup: filter.tag_groups, onTagGroupClick: function (group) {
            var currentTags = __spreadArrays(filter.tag_groups || []);
            if (currentTags.includes(group.id) || currentTags.includesLowercase(group.name)) {
                currentTags = currentTags.filter(function (t) { return !(t == group.id || t.toLowerCase() == group.name.toLowerCase()); });
            }
            else {
                currentTags.push(group.name);
            }
            setFilter(function (filter) {
                return __assign(__assign({}, filter), { tag_groups: currentTags });
            });
        }, selectedGenre: filter.genre, onGenreClick: function (genre) {
            setFilter(function (filter) {
                if (filter.genre && filter.genre == genre.name) {
                    return __assign(__assign({}, filter), { genre: undefined, subgenre: [] });
                }
                return __assign(__assign({}, filter), { genre: genre.name, subgenre: [] });
            });
        }, selectedSubGenres: filter.subgenre, onSubGenreClick: function (subgenre) {
            setFilter(function (filter) {
                if (filter.subgenre && filter.subgenre.includesLowercase(subgenre.name)) {
                    return __assign(__assign({}, filter), { subgenre: filter.subgenre.filter(function (g) {
                            return g.toLowerCase() != subgenre.name.toLowerCase();
                        }), genre: undefined });
                }
                else
                    return __assign(__assign({}, filter), { subgenre: (filter.subgenre || []).concat(subgenre.name), genre: undefined });
            });
        }, selectedKey: filter.key, onKeyClick: function (key) {
            if (filter.key == key) {
                setFilter(function (filter) {
                    return __assign(__assign({}, filter), { key: undefined });
                });
            }
            else {
                setFilter(function (filter) {
                    return __assign(__assign({}, filter), { key: key });
                });
            }
        }, selectedKeyType: filter.keyType || 'flats', onSelectedKeyTypeChange: function (keyType) {
            setFilter(function (filter) {
                return __assign(__assign({}, filter), { keyType: keyType });
            });
        }, bpmMax: filter.bpm_max, bpmMin: filter.bpm_min, onBPMChange: function (min, max) {
            setFilter(function (filter) {
                return __assign(__assign({}, filter), { bpm_max: max, bpm_min: min });
            });
        } }));
};
export default FilterWrapper;
//# sourceMappingURL=FilterWrapper.js.map